import { useMemo } from "react";

import { filterNavEntries, type NavEntryLike } from "../filter-nav-entries";
import { useUser } from "@/features/auth/hooks/use-user";

/** Nav entries the current viewer is allowed to see. */
export function useVisibleNav<T extends NavEntryLike>(entries: T[]): T[] {
  const { permissions } = useUser();

  return useMemo(() => filterNavEntries(entries, permissions), [entries, permissions]);
}
